'use strict';

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var defineProperty = require('./defineProperty-754b29ce.js');

var React = require('react');

var index = require('./index-6b8189f0.js');

var getDisplayName = require('./getDisplayName-fd5924a6.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React); // For a discussion on pitfalls, see
// https://gist.github.com/staltz/08bf613199092eeb41ac8137d51eb5e6


var Redraw = /*#__PURE__*/function (_React__default$defau) {
  _inherits(Redraw, _React__default$defau);

  var _super = _createSuper(Redraw);

  function Redraw() {
    var _this;

    _classCallCheck(this, Redraw);

    _this = _super.apply(this, arguments);

    defineProperty._defineProperty(_assertThisInitialized(_this), "state", {
      lastDraw: -1
    });

    defineProperty._defineProperty(_assertThisInitialized(_this), "draw", function () {
      _this.raf = requestAnimationFrame(_this.draw);
      var interval = _this.props.interval;
      var lastDraw = _this.state.lastDraw;
      var now = Date.now();
      var delta = now - lastDraw;

      if (lastDraw === -1 || delta > interval) {
        _this.setState({
          lastDraw: Math.round(now / interval) * interval
        });
      }
    });

    return _this;
  }

  _createClass(Redraw, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.raf = null;
      this.draw();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.raf && cancelAnimationFrame(this.raf);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children();
    }
  }]);

  return Redraw;
}(React__default["default"].PureComponent);

defineProperty._defineProperty(Redraw, "propTypes", {
  interval: index.PropTypes.number,
  children: index.PropTypes.func.isRequired
});

defineProperty._defineProperty(Redraw, "defaultProps", {
  interval: 1000
});

var hocWrap = function hocWrap(Component, interval) {
  var HOC = function HOC(props) {
    return /*#__PURE__*/React__default["default"].createElement(Redraw, {
      interval: interval
    }, function () {
      return /*#__PURE__*/React__default["default"].createElement(Component, props);
    });
  };

  HOC.displayName = "Redraw(".concat(getDisplayName._default(Component), ")");
  return HOC;
};

Redraw.hocWrap = hocWrap;
exports.Redraw = Redraw;